<template>
  <q-dialog v-model="status" class="search-dialog">
    <q-card class="q-dialog-plugin card-vue" style="width: 800px; max-width: 80vw;" v-if="status">
      <q-card-actions>
        <span class="text-h6"> 采购单号</span>
      </q-card-actions>
      <div class="p10">
        <div class="fix mb10">
          <q-input class="w180 l mr10" :dense="true" outlined placeholder="输入采购申请单单号查询" v-model="query.FPRBILLNO" square clearable>
          </q-input>
          <q-btn size='9px' class="l mr10" color="primary" icon="fas fa-search" @click="search"></q-btn>
        </div>
        <div>
          <base-table v-if="!tableSet.loading" @tool_click="tool_click" :tableSet="tableSet" @changeRowsPage="changeRowsPage" @changePage="changePage" @updateSelected="updateSelected"></base-table>
          <q-skeleton :height="tableSet.height" v-if="tableSet.loading" />
        </div>
      </div>
      <q-card-actions align="right">
        <q-btn label="取消" size='9px' @click="onCancel"/>
        <q-btn color="primary" size='9px' label="确定" @click="onOk"/>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import {ref,onMounted} from 'vue'
import {useStore} from "vuex";
import {tableHeight} from "@/tools/lines.js";
import {isNotEmpty} from "@/tools/utils";
import BaseTable from '@/components/pieces/tables/default-table.vue';
export default {
  name: "purchase-dialog",
  components:{
    BaseTable
  },
  setup(props,context){
    let store = useStore();
    let query = ref({
      FPRBILLNO:''
    });
    let tableSet =store.getters["eorderetails/gePurchaseTableSet"];
    let status = ref(false);

    function search(){
      tableSet.pagination.page = 1;
      getTableData();
    }
    let changeRowsPage = (value)=>{
      localStorage.setItem("pageSize", value);
      tableSet.pagination.rowsPerPage = value;
      getTableData();
    }
    let changePage = (value)=>{
      tableSet.pagination.page = value;
      getTableData();
    }
    let updateSelected = (data)=>{}
    /**
     * 刷新表格高度
     */
    function refreshTableHeight() {
      store.commit("eorderetails/setTableHeight", tableHeight()+70);
    }
    function getParams(){
      let params={
        pagination: {
          rowsPerPage: tableSet.pagination.rowsPerPage,
          page: tableSet.pagination.page
        },
      };
      if(isNotEmpty(query.value.FPRBILLNO)){
        params.multi_query = {
          keys:query.value.FPRBILLNO.trim(),
          fields:["FPRBILLNO"]
        };
      }
      return params
    }
    function getTableData(){
      let params = getParams();
      store.dispatch("eorderetails/getList",params)
    }
    function init(){
      getTableData();
    }

    let onCancel = ()=>{
      status.value = false;
    };
    let open = ()=>{
      status.value = true;
      init();
      refreshTableHeight();
      window.onresize = () => {
        return (() => {
          refreshTableHeight();
        })();
      };
    }
    let onOk = ()=>{
      if(!isNotEmpty(tableSet.selected)){
        store.dispatch("response/set-api-response", {errorMessage:'请勾选采购申请后点击确认!'}, { root: true });
        return
      }
      context.emit('hadleOk',tableSet.selected);
      onCancel();
    }
    return{
      status,
      onCancel,
      open,
      onOk,
      query,
      search,
      changeRowsPage,
      changePage,
      updateSelected,
      tableSet
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.q-field--auto-height .q-field__native{
  min-height: 0px !important;
}
</style>
